module.exports = __webpack_public_path__ + "img/img-science-btn-1.4bf1dda3.png";